
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.6663 5.5C13.7823 5.5 12.9344 5.85119 12.3093 6.47631C11.6842 7.10143 11.333 7.94928 11.333 8.83333V10.1667H7.66634C5.82539 10.1667 4.33301 11.659 4.33301 13.5V25.1667C4.33301 27.0076 5.82539 28.5 7.66634 28.5H12.333H21.6663H26.333C28.174 28.5 29.6663 27.0076 29.6663 25.1667V13.5C29.6663 11.659 28.174 10.1667 26.333 10.1667H22.6663V8.83333C22.6663 7.94928 22.3152 7.10143 21.69 6.47631C21.0649 5.85119 20.2171 5.5 19.333 5.5H14.6663ZM20.6663 10.1667V8.83333C20.6663 8.47971 20.5259 8.14057 20.2758 7.89052C20.0258 7.64048 19.6866 7.5 19.333 7.5H14.6663C14.3127 7.5 13.9736 7.64048 13.7235 7.89052C13.4735 8.14057 13.333 8.47971 13.333 8.83333V10.1667H20.6663ZM13.333 12.1667H20.6663V26.5H13.333V12.1667ZM11.333 12.1667H7.66634C6.92996 12.1667 6.33301 12.7636 6.33301 13.5V25.1667C6.33301 25.903 6.92996 26.5 7.66634 26.5H11.333V12.1667ZM22.6663 26.5V12.1667H26.333C27.0694 12.1667 27.6663 12.7636 27.6663 13.5V25.1667C27.6663 25.903 27.0694 26.5 26.333 26.5H22.6663Z","fill":"currentColor"}})])
          )
        }
      }
    